import React from 'react'
import HOC from '../HOC'

const AboutPage = () => {
  return (
    <div className="mx-5 my-5">
      <h2>About Diamond</h2>
      <div className="my-5"></div>
      <p className="lead">
        Diamond Consulting is owned and managed by Cyndi Stempien. Ms. Stempien has 23 years of 
        experience in housing, 14 of which have been spent focused in areas of affordable housing. 
        Her expertise ranges from site and multi-site management, to Director of Compliance and VP 
        of Strategic Operations. She holds certifications for COS (Certified Occupancy Specialist), 
        AHM (Assisted Housing Manager), PHM (Public Housing Manager) and C3P (Certified Credit 
        Compliance Professional). She possesses a vast understanding of the importance of a solid 
        compliance program in order to meet the stringent regulatory requirements of LIHTC, HOME 
        Funds, Section 8, and Public Housing. In addition, she embraces the learning process and 
        has a large focus on "getting it right the first time!" File reviews are performed in an 
        ongoing training style to assist property management professionals in becoming experts at 
        what they do!
      </p>
      <p className="lead">
        Affordable housing requires that every project remain in compliance during the entire 
        compliance period as required by each of the individual funding sources and/or regulatory 
        agencies involved. The penalties for failure to comply or having a poorly managed compliance 
        program can cost owners huge sums of money, prevent owners from participating in future 
        affordable housing projects, and cause government agencies and investors to implement more 
        intense levels of supervision. Residents can be impacted, as those that occupy units that 
        were not properly qualified could be evicted as a result of a poorly managed compliance program.
      </p>
      <p className="lead">
        Let Diamond Consulting assist you in achieving a rock solid compliance program.
      </p>
      <div className="my-5"></div>
      <h4 className="text-center">
        Ask us what we can do for you in terms of compliance, information technology and marketing!
      </h4>
    </div>
  )
}

export default HOC(AboutPage)

